/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'chat.bsky.group.rejectJoinRequest'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  member: /*#__PURE__*/ l.string({ format: 'did' }),
  convoId: /*#__PURE__*/ l.string(),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Rejects a request to join a group (via join link) the user owns. Action taken by the group owner. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidConvo',
  'InsufficientRole',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
